<template>
  <v-row justify="center" class="ma-0">
    <v-col cols="12" class="pa-0">
      <v-toolbar :color="getCategoryColor(myTemplate)" height="60" dark class="elevation-0">
        <v-toolbar-title>{{ '[' + $ACTION_TABLE[myTemplate.action - 1].name + '] ' + (myTemplate.title ? myTemplate.title : '') }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-col>
    <v-col cols="12" class="pa-0">
      <v-card tile>
        <v-card-text class="pa-1 overflow-y-auto" :style="dialogHeight">
          <v-container>
            <v-row align="center">
              <v-col cols="5" class="py-0">
                <v-select
                  ref="category"
                  :items="$DESCRIPTIONS_ITEMS"
                  label="*分類"
                  v-model.number="myTemplate.category"
                  item-text="name"
                  item-value="key"
                  :rules="[rules.required]"
                  @change="onChangeCategory()"
                  :disabled="task == 'template' && myTemplate.key != null"
                ></v-select>
              </v-col>
              <v-col cols="4" class="py-0">
                <v-select
                  ref="month"
                  :items="$MONTHS13_TABLE"
                  label="*月"
                  v-model="myTemplate.month"
                  :rules="[rules.noneZero]"
                  item-text="name"
                  item-value="value"
                ></v-select>
              </v-col>
              <v-col cols="3" class="py-0">
                <v-select
                  ref="week"
                  :items="$WEEK_ZONE_TABLE"
                  label="*週"
                  v-model.number="myTemplate.week"
                  :rules="[rules.noneZero]"
                  item-text="name"
                  item-value="value"
                  :disabled="task == 'task'"
                ></v-select>
              </v-col>
              <v-col cols="9" class="py-0">
                <v-select
                  v-if="task == 'task'"
                  ref="templates"
                  :items="filteredTemplates"
                  label="*項目"
                  v-model="myTemplate.key"
                  :rules="[rules.required]"
                  item-text="title"
                  item-value="key"
                  @change="onChangeTemplate()"
                >
                </v-select>
                <v-text-field
                  v-else
                  ref="title"
                  v-model="myTemplate.title"
                  :rules="[rules.required]"
                  label="*項目"
                  :disabled="task == 'task'"
                ></v-text-field>
              </v-col>
              <v-col cols="3" class="py-0">
                  <v-select
                    ref="action"
                    :items="$ACTION_TABLE"
                    label="*行動"
                    v-model.number="myTemplate.action"
                    :rules="[rules.required]"
                    item-text="name"
                    item-value="key"
                    :disabled="task == 'task'"
                  ></v-select>
              </v-col>
              <v-col cols="12" class="py-0">
                <v-textarea
                  prepend-inner-icon="mdi-pencil-box"
                  name="description"
                  label="説明"
                  v-model="myTemplate.description"
                  hide-details
                  outlined
                  rows="4"
                  :disabled="task == 'task'"
                >
                </v-textarea>
              </v-col>
              <v-col v-if="task == 'task'" cols="12" class="px-0 pb-0" align="center">
                <v-row class="ma-0" align="start" justify="center">
                  <v-col cols="1" class="py-0" align="center">
                    <v-icon :color="getTagColor()" class="py-2">mdi-tag</v-icon>
                  </v-col>
                  <v-col cols="10" class="py-0">
                    <v-combobox
                      :items="tags"
                      v-model="tag"
                      item-text="name"
                      item-value="key"
                      hideDetails
                      clearable
                      dense
                    ></v-combobox>
                  </v-col>
                  <v-col cols="1" class="pl-0 py-0" align="center">
                    <template-tags :invisible="true"  class="py-1" @added="onAdded"></template-tags>
                  </v-col>
                </v-row>
              </v-col>
              <template v-if="task == 'task'">
                <v-col cols="6" class="pb-0">
                  <template-date-picker
                    :id="3"
                    :icon="'event'"
                    :date="myItem.startDate"
                    :label="'開始日'"
                    :title="false"
                    @updated="onUpdated"
                  ></template-date-picker>
                </v-col>
                <v-col cols="6" class="pb-0">
                  <template-date-picker
                    :id="4"
                    :icon="'event'"
                    :date="myItem.endDate"
                    :label="'締切日'"
                    :title="false"
                    @updated="onUpdated"
                    :validate="validate"
                  ></template-date-picker>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-textarea
                    prepend-inner-icon="mdi-pencil-box"
                    name="description"
                    label="目標"
                    v-model="myItem.target"
                    hideDetails
                    outlined
                    rows="4"
                  >
                  </v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    prepend-inner-icon="mdi-pencil-box"
                    name="description"
                    label="実績"
                    v-model="myItem.result"
                    hideDetails
                    outlined
                    rows="4"
                  >
                  </v-textarea>
                </v-col>
                <v-col v-if="task == 'task' && !myItem.key" cols="12" class="py-0">
                  <v-select
                    ref="assign"
                    prepend-icon="mdi-account-circle-outline"
                    :items="scopes"
                    label="範囲"
                    v-model="myScope"
                    dense
                    auto-grow
                    multiple
                    item-text="name"
                    item-value="key"
                    :disabled="task == 'template'"
                    class="caption"
                    small-chips
                    :rules="[rules.required]"
                    :error="assignError"
                  ></v-select>
                </v-col>
                <v-row v-else>
                  <v-col cols="5" class="py-0">
                    <v-select
                      :prepend-icon="myItem.status ? $TASK_STATUS[myItem.status - 1].icon : 'mdi-bell-outline'"
                      :items="$TASK_STATUS"
                      label="進捗"
                      v-model.number="myItem.status"
                      item-text="name"
                      item-value="key"
                    ></v-select>
                  </v-col>
                  <v-col cols="1" class="px-1">
                    <v-avatar size="30">
                      <img v-if="getAvatar(myItem)" :src='getAvatar(myItem)'>
                      <v-avatar v-else size="30" :color="getGroupColor(myItem)"><span class="font-weight-bold white--text" style="font-size:22px; user-select: none;">{{ getNamePrefix(myItem) }}</span></v-avatar>
                    </v-avatar>
                  </v-col>
                  <v-col cols="6" class="py-0">
                    <v-select
                      :items="filteredUsers"
                      label="担当"
                      v-model="myItem.charge"
                      item-text="name"
                      item-value="key"
                      clearable
                    ></v-select>
                  </v-col>
                </v-row>
              </template>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded depressed @click.native="close()">取消</v-btn>
          <v-btn rounded depressed color="primary" @click.native="onSubmit()">{{ getButtonLable() }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import * as async from 'async'
import Moment from 'moment-timezone'
import { extendMoment } from 'moment-range'
import TemplateTags from '../user/TemplateTags.vue'
Vue.component('template-tags', TemplateTags)
const moment = extendMoment(Moment)
export default {
  data () {
    return {
      startDate: false,
      loading: false,
      scopes: [],
      myScope: null,
      myLocal: false,
      myItem: null,
      myTemplate: null,
      category: null,
      month: 0,
      week: 1,
      validate: false,
      assignError: false,
      tag: null,
      rules: {
        required: value => !!value || '必須',
        noneZero: value => {
          return value !== null || '必須'
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      tags: 'tags/tags',
      templateTasks: 'templateTasks/templates',
      chatRefStatus: 'chatRefStatus/chatRef',
      windowSize: 'shared/windowSize'
    }),
    form () {
      return {
        category: this.myTemplate.category,
        title: this.myTemplate.title,
        month: this.myTemplate.month,
        week: this.myTemplate.week,
        action: this.myTemplate.action
      }
    },
    filteredTemplates () {
      var temp = []
      for (var i in this.templateTasks) {
        if (this.myTemplate.category === this.templateTasks[i].category && (this.myTemplate.month === this.templateTasks[i].month)) {
          temp.push(JSON.parse(JSON.stringify(this.templateTasks[i])))
        }
      }
      return temp
    },
    filteredUsers () {
      var temp = []
      var keys = Object.keys(this.myItem.groups)
      var group = null
      for (var x in keys) {
        if (this.myItem.groups[keys[x]]) {
          var index = this.groups.findIndex(g => g.key === keys[x])
          if (index !== -1) {
            group = JSON.parse(JSON.stringify(this.groups[index]))
          }
          break
        }
      }
      if (group) {
        if (group.classroom) {
          var uKeys = Object.keys(group.users)
          for (var y in uKeys) {
            if (group.users[uKeys[y]]) {
              index = this.users.findIndex(u => u.key === uKeys[y])
              if (index !== -1) {
                temp.push(JSON.parse(JSON.stringify(this.users[index])))
              }
            }
          }
        } else {
          index = this.chatRefStatus.findIndex(c => c.key === group.key)
          if (index !== -1) {
            var mKeys = Object.keys(this.chatRefStatus[index].members)
            for (var z in mKeys) {
              if (this.chatRefStatus[index].members[mKeys[z]]) {
                var uIndex = this.users.findIndex(u => u.key === mKeys[z])
                if (uIndex !== -1) {
                  temp.push(JSON.parse(JSON.stringify(this.users[uIndex])))
                }
              }
            }
          }
        }
      }
      temp.sort(function (a, b) {
        if (a.name > b.name) return -1
        if (a.name < b.name) return 1
        return 0
      })
      return temp
    },
    dialogHeight () {
      var h = Math.round(this.windowSize.y * 0.6)
      h = h > 700 ? 700 : h
      return 'max-height: ' + String(h) + 'px; overflow-x: hidden;'
    }
  },
  watch: {
    myScope () {
      if (Object.keys(this.myScope).length !== 0) {
        this.assignError = false
      }
    }
  },
  props: [ 'item', 'dialog', 'task' ],
  created () {
    if (this.task === 'task') {
      if (this.item) {
        this.myItem = JSON.parse(JSON.stringify(this.$store.getters['scheduleTasks/initial']))
        var item = JSON.parse(JSON.stringify(this.item))
        var keys = Object.keys(this.myItem)
        for (var i in keys) {
          if (typeof item[keys[i]] !== 'undefined') {
            this.myItem[keys[i]] = item[keys[i]]
          }
        }
        if (this.myItem.tag) {
          var index = this.tags.findIndex(t => t.key === this.myItem.tag)
          if (index !== -1) {
            this.tag = this.tags[index]
          }
        }
        if (!this.myItem.endDate) {
          this.myItem.endDate = this.myItem.startDate
          this.myItem.end = this.myItem.start
        }
        this.myTemplate = JSON.parse(JSON.stringify(this.$store.getters['templateTasks/initial']))
        if (item.template) {
          index = this.templateTasks.findIndex(template => template.key === item.template)
          if (index !== -1) {
            this.myTemplate = JSON.parse(JSON.stringify(this.templateTasks[index]))
          }
        } else {
          this.myTemplate.category = item.category
        }
      } else {
        this.myItem = JSON.parse(JSON.stringify(this.$store.getters['scheduleTasks/initial']))
        this.myTemplate = JSON.parse(JSON.stringify(this.$store.getters['templateTasks/initial']))
      }
    } else {
      if (this.item) {
        this.myTemplate = JSON.parse(JSON.stringify(this.item))
      } else {
        this.myTemplate = JSON.parse(JSON.stringify(this.$store.getters['templateTasks/initial']))
      }
      this.month = this.myTemplate.month
    }
    keys = Object.keys(this.data.schools)
    for (i in keys) {
      if (this.data.schools[keys[i]]) {
        index = this.schools.findIndex(school => school.key === keys[i])
        if (index !== -1) {
          this.school = this.schools[index]
        }
      }
    }
    this.createScopes()
  },
  methods: {
    createScopes () {
      if (this.task === 'template') {
        return
      }
      this.scopes = []
      this.myScope = []
      if (!this.data) {
        return
      }
      if (this.data.order) {
        for (var i in this.data.order) {
          var index = this.groups.findIndex(group => group.key === this.data.order[i])
          if (index !== -1) {
            if (this.groups[index].enable && this.groups[index].classroom) {
              this.scopes.push({
                type: 'group',
                name: this.groups[index].name,
                key: this.groups[index].key,
                item: this.groups[index],
                disabled: false
              })
            }
          }
        }
      } else {
        var keys = Object.keys(this.data.groups)
        for (i in keys) {
          if (this.data.groups[keys[i]]) {
            index = this.groups.findIndex(g => g.key === keys[i])
            if (index !== -1) {
              if (this.groups[index].enable && this.groups[index].classroom) {
                this.scopes.push({
                  type: 'group',
                  name: this.groups[index].name,
                  key: this.groups[index].key,
                  item: this.groups[index],
                  disabled: false
                })
              }
            }
          }
        }
      }
      index = this.chatRefStatus.findIndex(c => c.key === this.data.key)
      if (index !== -1) {
        keys = Object.keys(this.chatRefStatus[index].members)
        for (i in keys) {
          index = this.groups.findIndex(g => g.key === keys[i])
          if (index !== -1) {
            if (this.groups[index].enable && !this.groups[index].classroom && this.groups[index].task) {
              this.scopes.push({
                type: 'group',
                name: this.groups[index].name,
                key: this.groups[index].key,
                item: this.groups[index],
                disabled: false
              })
            }
          }
        }
      }
      keys = Object.keys(this.myItem.groups)
      for (i in keys) {
        this.myScope.push(keys[i])
      }
    },
    getTagColor () {
      if (this.tag) {
        var index = this.tags.findIndex(t => t.key === this.tag.key)
        if (index !== -1) {
          return this.tags[index].color
        }
      }
      return 'grey'
    },
    getAvatar (item) {
      var url = null
      var keys = Object.keys(item.groups)
      for (var i in keys) {
        var index = this.groups.findIndex(g => g.key === keys[i])
        if (index !== -1) {
          if (this.groups[index].avatar) {
            return this.groups[index].avatar.thumbnail
          } else {
            break
          }
        }
      }
      return url
    },
    getNamePrefix (item) {
      var name = '？'
      var keys = Object.keys(item.groups)
      for (var i in keys) {
        var index = this.groups.findIndex(g => g.key === keys[i])
        if (index !== -1) {
          if (this.groups[index].name) {
            name = this.groups[index].name.slice(0, 1)
          } else {
            break
          }
        }
      }
      return name
    },
    getGroupColor (item) {
      var keys = Object.keys(item.groups)
      for (var i in keys) {
        var index = this.groups.findIndex(g => g.key === keys[i])
        if (index !== -1) {
          if (this.groups[index].name) {
            return this.groups[index].color ? this.groups[index].color : 'primary'
          }
        }
      }
      return 'primary'
    },
    getGroupName () {
      var keys = Object.keys(this.myItem.groups)
      for (var i in keys) {
        var index = this.groups.findIndex(g => g.key === keys[i])
        if (index !== -1) {
          return this.groups[index].name
        }
      }
      return ''
    },
    getButtonLable () {
      if (this.task === 'task') {
        return this.myItem.key ? '更新' : '追加'
      } else {
        return this.myTemplate.key ? '更新' : '追加'
      }
    },
    onPrivate () {
      this.myLocal = !this.myLocal
      if (!this.myLocal) {
        this.myScope = []
      }
    },
    onChangeCategory () {
      var temp = JSON.parse(JSON.stringify(this.myTemplate))
      this.myTemplate = JSON.parse(JSON.stringify(this.$store.getters['templateTasks/initial']))
      this.myTemplate.category = temp.category
      if (this.task === 'task') {
        this.myItem.template = null
      }
    },
    onChangeTemplate () {
      var index = this.templateTasks.findIndex(t => t.key === this.myTemplate.key)
      if (index !== -1) {
        this.myTemplate = JSON.parse(JSON.stringify(this.templateTasks[index]))
        this.myItem.template = this.myTemplate.key
      } else {
        this.myTemplate = JSON.parse(JSON.stringify(this.$store.getters['templateTasks/initial']))
      }
    },
    onUpdated: function (value) {
      switch (value.id) {
        case 3:
          this.myItem.startDate = value.date
          break
        case 4:
          this.myItem.endDate = value.date
          break
      }
    },
    onAdded: function (value) {
      if (value) {
        var index = this.tags.findIndex(t => t.key === value)
        if (index !== -1) {
          this.tag = this.tags[index]
        } else {
          this.tag = null
        }
      }
    },
    onSubmit () {
      var vm = this
      this.assignError = false
      this.formHasErrors = false
      if (this.task === 'template') {
        Object.keys(this.form).forEach(f => {
          if (this.form[f] === null) {
            this.formHasErrors = true
          }
          this.$refs[f].validate(true)
        })
      } else {
        if (!this.myTemplate.key) {
          this.$refs.templates.validate(true)
          this.formHasErrors = true
        }
        if (Object.keys(this.myScope).length === 0) {
          this.assignError = true
          this.formHasErrors = true
        }
      }
      if (this.task === 'task') {
        var diff = moment(this.myItem.endDate, 'YYYY-MM-DD').diff(moment(this.myItem.startDate, 'YYYY-MM-DD'), 'days')
        if (diff < 0) {
          this.myItem.endDate = this.myItem.startDate
          this.myItem.end = this.myItem.start
          this.formHasErrors = true
        }
      }
      if (this.formHasErrors) {
        return
      }
      vm.loading = true
      this.$nextTick(function () {
        var payload = null
        if (this.task === 'task') {
          payload = JSON.parse(JSON.stringify(this.$store.getters['scheduleTasks/initial']))
          var item = JSON.parse(JSON.stringify(this.myItem))
          var keys = Object.keys(payload)
          for (var i in keys) {
            payload[keys[i]] = item[keys[i]]
          }
          if (typeof this.tag === 'undefined' || this.tag === null) {
            payload.tag = null
          } else {
            var index = this.tags.findIndex(t => t.key === this.tag.key)
            if (index !== -1) {
              payload.tag = this.tag.key
            } else {
              payload.tag = null
            }
          }
          var start = moment(payload.startDate)
          moment.tz.setDefault('Asia/Tokyo')
          payload.start = {
            date: start.format('YYYY-MM-DD'),
            yyyy: parseInt(start.format('YYYY')),
            mm: parseInt(start.format('MM')),
            dd: parseInt(start.format('DD'))
          }
          var end = moment(payload.endDate)
          payload.end = {
            date: end.format('YYYY-MM-DD'),
            yyyy: parseInt(end.format('YYYY')),
            mm: parseInt(end.format('MM')),
            dd: parseInt(end.format('DD'))
          }
          payload.duration = diff + 1
          payload.schools[this.school.key] = true
          if (!payload.key) {
            payload.createdAt = parseInt(new Date().getTime())
          }
          payload.updatedAt = parseInt(new Date().getTime())
          async.eachSeries(this.myScope, function (scope, cb) {
            var groups = {}
            groups[scope] = true
            payload.groups = groups
            vm.$store.dispatch('scheduleTasks/write', JSON.parse(JSON.stringify(payload))).then((resp) => {
              cb()
            })
          }, function (error) {
            if (error) {
              console.log(error)
            }
            vm.loading = false
            vm.close()
          })
        } else {
          payload = JSON.parse(JSON.stringify(this.$store.getters['templateTasks/initial']))
          item = JSON.parse(JSON.stringify(this.myTemplate))
          keys = Object.keys(payload)
          for (i in keys) {
            payload[keys[i]] = item[keys[i]]
          }
          payload.schools[this.school.key] = true
          if (!payload.key) {
            payload.createdAt = parseInt(new Date().getTime())
          }
          payload.updatedAt = parseInt(new Date().getTime())
          vm.$store.dispatch('templateTasks/write', JSON.parse(JSON.stringify(payload))).then((resp) => {
            vm.loading = false
            vm.close()
          })
        }
      })
    },
    close () {
      this.$emit('dismissed', null)
    }
  }
}
</script>
